var module;
// LICENSE_CODE ZON ISC
'use strict'; /*zlint node, br*/
(function () {
  var is_node = typeof module == 'object' && module.exports && module.children;
  var qs;
  if (!is_node) ;else {
    // XXX arik HACK: react-native bundler will try to require querystring
    // even thoguh it never reaches this if (it is done in pre-processing)
    // so we fool him
    var _require = require;
    qs = _require('querystring');
  }
  define(['/util/util.js', '/util/string.js'], function (zutil, zstring) {
    var assign = Object.assign;
    var E = {};
    function replace_slashes(url) {
      return url.replace(/\\/g, '/');
    }
    E.add_proto = function (url) {
      if (!url.match(/^([a-z0-9]+:)?\/\//i)) url = 'http://' + url;
      return url;
    };
    E.rel_proto_to_abs = function (url) {
      var proto = is_node ? 'http:' : location.protocol;
      return url.replace(/^\/\//, proto + '//');
    };
    E.get_top_level_domain = function (host) {
      var n = host.match(/\.([^.]+)$/);
      return n ? n[1] : '';
    };
    E.get_host = function (url) {
      if (url.indexOf('chrome://') == 0) {
        var ch_host = url.split('chrome://')[1].split('/')[0];
        return ch_host;
      }
      var n = replace_slashes(url).match(/^(https?:)?\/\/([^/]+)\/.*$/);
      return n ? n[2] : '';
    };
    E.get_host_without_tld = function (host) {
      return host.replace(/^([^.]+)\.[^.]{2,3}(\.[^.]{2,3})?$/, '$1');
    };
    var generic_2ld = {
      com: 1,
      biz: 1,
      net: 1,
      org: 1,
      xxx: 1,
      edu: 1,
      gov: 1,
      ac: 1,
      co: 1,
      or: 1,
      ne: 1,
      kr: 1,
      jp: 1,
      jpn: 1,
      cn: 1,
      mil: 1,
      info: 1,
      int: 1
    };

    // taken from popular collection, full list:
    // https://publicsuffix.org/list/public_suffix_list.dat
    var non_generic_2ld = ['bc.ca', 'bel.tr', 'bet.ar', 'blog.br', 'ca.us', 'ce.it', 'def.br', 'dn.ua', 'fl.us', 'g12.br', 'ga.us', 'gc.ca', 'go.cr', 'go.id', 'go.jp', 'go.ke', 'go.kr', 'go.th', 'gob.ar', 'gob.bo', 'gob.cl', 'gob.do', 'gob.ec', 'gob.es', 'gob.gt', 'gob.hn', 'gob.mx', 'gob.pa', 'gob.pe', 'gob.sv', 'gob.ve', 'gop.pk', 'gos.pk', 'gouv.fr', 'gouv.ht', 'govt.nz', 'gv.at', 'health.nz', 'hs.kr', 'idf.il', 'idv.tw', 'il.us', 'in.rs', 'in.th', 'in.ua', 'ind.in', 'inf.br', 'jus.br', 'kh.ua', 'kharkov.ua', 'kiev.ua', 'kommune.no', 'ks.ua', 'kyiv.ua', 'lazio.it', 'leg.br', 'lg.ua', 'lviv.ua', 'mb.ca', 'me.uk', 'mi.us', 'mil.by', 'mil.iq', 'mn.us', 'mus.br', 'my.id', 'nhs.uk', 'nic.in', 'nj.us', 'nm.us', 'ny.us', 'od.ua', 'odessa.ua', 'of.by', 'oh.us', 'pa.us', 'pe.kr', 'police.uk', 'pro.in', 'qc.ca', 'rep.kp', 'res.in', 'rv.ua', 'sch.id', 'te.ua', 'tx.us', 'web.id', 'web.tr'];
    var non_generic_2ld_re = domains_re(non_generic_2ld);
    E.get_root_domain = function (domain) {
      if (E.is_ip(domain)) return domain;
      var s = domain.split('.'),
        root = s,
        len = s.length;
      if (non_generic_2ld_re.test(domain)) root = s.slice(-3, len);else if (len > 2)
        // www.abc.com abc.com.tw www.abc.com.tw,...
        {
          var hd = 0;
          if (s[len - 1] == 'hola') {
            hd = 2; // domain.us.hola
            if (s[len - 2].match(/^\d+$/)) hd = 3; // domain.us.23456.hola
          }
          if (generic_2ld[s[len - 2 - hd]]) root = s.slice(-3 - hd, len - hd); // abc.com.tw
          else root = s.slice(-2 - hd, len - hd); // abc.com
        }
      return root.join('.');
    };
    E.is_domain_suffix = function (domain) {
      domain = 'test.' + domain;
      return E.get_root_domain(domain) == domain;
    };

    // XXX josh: move to email.js:get_domain
    E.get_domain_email = function (email) {
      var match = email.toLowerCase().match(/^[a-z0-9_.\-+*%]+@(.*)$/);
      return match && match[1];
    };

    // XXX josh: move to email.js:get_root_domain or remove and let developer
    // combine email.js:get_domain with url.js:get_root_domain
    E.get_root_domain_email = function (email) {
      var domain = E.get_domain_email(email);
      return domain && E.get_root_domain(domain);
    };
    E.get_path = function (url) {
      var n = url.match(/^https?:\/\/[^/]+(\/.*$)/);
      return n ? n[1] : '';
    };
    E.get_proto = function (url) {
      var n = url.match(/^([a-z0-9]+):\/\//);
      return n ? n[1] : '';
    };
    E.get_host_gently = function (url) {
      var n = replace_slashes(url).match(/^(?:(?:[a-z0-9]+?:)?\/\/)?([^/]+)/);
      return n ? n[1] : '';
    };
    E.is_ip = function (host) {
      var m = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(host);
      if (!m) return false;
      for (var i = 1; i <= 4; i++) {
        if (+m[i] > 255) return false;
      }
      return true;
    };
    E.is_ip_mask = function (host) {
      var m = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(host);
      if (!m) return false;
      if (E.ip2num(host) == 0) return false;
      var final = false;
      var check_num_mask = function check_num_mask(num) {
        var arr = (num >>> 0).toString(2).split(''),
          fin = false;
        for (var i = 0; i < arr.length; i++) {
          if (fin && arr[i] == '1') return false;
          if (!fin && arr[i] == '0') fin = true;
        }
        return true;
      };
      for (var i = 1; i <= 4; i++) {
        if (+m[i] > 255) return false;
        if (final && +m[i] > 0) return false;
        if (!final && +m[i] < 255) {
          if (!check_num_mask(+m[i])) return false;
          final = true;
        }
      }
      return !!final;
    };
    E.ip2num = function (ip) {
      var num = 0;
      ip.split('.').forEach(function (octet) {
        num <<= 8;
        num += +octet;
      });
      return num >>> 0;
    };
    E.num2ip = function (num) {
      return (num >>> 24) + '.' + (num >> 16 & 255) + '.' + (num >> 8 & 255) + '.' + (num & 255);
    };
    E.is_ip_subnet = function (host) {
      var m = /(.+?)\/(\d+)$/.exec(host);
      return m && E.is_ip(m[1]) && +m[2] <= 32;
    };
    E.cbl_key2sub = function (ip) {
      return ip.replace(/_/g, '.') + '/24';
    };
    E.is_ip_netmask = function (host) {
      if (!host || typeof host.split !== 'function') return false;
      var ips = host.split('/');
      if (ips.length != 2 || !E.is_ip(ips[0]) || !E.is_ip_mask(ips[1])) return false;
      return true;
    };
    E.is_ip_range = function (host) {
      if (typeof host.split !== 'function') return false;
      var ips = host.split('-');
      if (ips.length != 2 || !E.is_ip(ips[0]) || !E.is_ip(ips[1])) return false;
      return E.ip2num(ips[0]) < E.ip2num(ips[1]);
    };
    E.is_ip_port = function (host) {
      var m = /(.+?)(?::(\d{1,5}))?$/.exec(host);
      return m && E.is_ip(m[1]) && !(+m[2] > 65535);
    };

    /* basic url validation to prevent script injection like 'javascript:....' */
    E.is_valid_url = function (url) {
      return /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9-]+(:\d+)?(\/.*)?$/i.test(url);
    };
    E.is_valid_domain = function (domain) {
      return /^([a-z0-9]([a-z0-9-_]*[a-z0-9])?\.)+[a-z]{2,63}$/.test(domain) || /^(new-tab-page|hola-new-tab-page)$/.test(domain) || /^(hola-diagnostics|hola-settings|settings)$/.test(domain);
    };

    // must be the same as in server_conf.js
    E.hola_domains = ['hola.org', 'zspeed-cdn.com', 'h-vpn.org', 'holavpn.com', 'holavpnworld.com', 'holavpnextension.com', 'holavpninstaller.com', 'holasof.com', 'holabrowser.com', 'holafreevpn.com', 'holavpnrussia.com', 'hola-vpn.com', 'holax.io', 'holavpn.net', 'holavpnandroid.com', 'c6gj-static.net', 'su89-cdn.net', 'yd6n63ptky.com', 'yg5sjx5kzy.com', 'kbz0pwvxmv.com', 'wbzby2a2k9.com', 'hola-compat.com', 'x-cdn-static.com', 'mc5smy5d7h.com', 'tszbegfdw9.com'];
    var additional_domains = ['haffnetwork\\w{2}.com'];
    E.hola_ext_domains = ['shoopit.com', 'toolip.io', 'oculusproxies.com', 'browser.ai'];
    E.hola_browser_internal_domains = ['new-tab-page', 'hola-new-tab-page', 'hola-diagnostics', 'hola-settings', 'settings'];
    function domains_re(arr) {
      var domains = arr.join('|').replace(/\./g, '\\.');
      return new RegExp('^(.*\\.)?(' + domains + ')$');
    }
    function init_hola_domains_re() {
      var domains = E.hola_domains.concat(additional_domains).concat(E.hola_browser_internal_domains).concat(E.hola_ext_domains);
      return domains_re(domains);
    }
    var hola_domain_re = init_hola_domains_re();
    E.is_hola_domain = function (domain) {
      return E.is_valid_domain(domain) && domain.search(hola_domain_re) != -1;
    };
    E.is_hola_url = function (url) {
      return E.is_hola_domain(E.get_host(url));
    };

    // XXX josh: move to email.js:is_valid
    E.is_valid_email = function (email) {
      if (!email) return false;
      var re = /^[a-z0-9_\-+*]+(?:\.[a-z0-9_\-+*]+)*@(.*)$/;
      var n = email.toLowerCase().match(re);
      return !!(n && E.is_valid_domain(n[1]));
    };

    // XXX dmitriie: move to email.js:is_alias
    E.is_alias_email = function (email) {
      if (!E.is_valid_email(email)) return false;
      var n = email.toLowerCase().match(/^([a-z0-9_.\-+*]+)@.*$/);
      return !!(n && /.+\+.+/.test(n[1]));
    };

    // XXX dmitriie: move to email.js:get_main
    E.get_main_email = function (email) {
      if (!E.is_valid_email(email)) return;
      if (E.is_alias_email(email)) return email.replace(/\+.+@/, '@');
      return email;
    };
    E.is_ip_in_range = function (ips_range, ip) {
      if (!E.is_ip_range(ips_range) || !E.is_ip(ip)) return false;
      var ips = ips_range.split('-');
      var min_ip = E.ip2num(ips[0]),
        max_ip = E.ip2num(ips[1]);
      var num_ip = E.ip2num(ip);
      return num_ip >= min_ip && num_ip <= max_ip;
    };
    E.is_ip_local = function (ip) {
      return E.is_ip_in_range('10.0.0.0-10.255.255.255', ip) || E.is_ip_in_range('172.16.0.0-172.31.255.255', ip) || E.is_ip_in_range('192.168.0.0-192.168.255.255', ip) || E.is_ip_in_range('169.254.0.0-169.254.255.255', ip);
    };
    E.host_lookup = function (lookup, host) {
      var pos;
      while (1) {
        if (host in lookup) return lookup[host];
        if ((pos = host.indexOf('.')) < 0) return;
        host = host.slice(pos + 1);
      }
    };

    // more-or-less compatible with NodeJS url API
    E.uri_obj_href = function (uri) {
      return (uri.protocol || '') + (uri.slashes ? '//' : '') + (uri.host ? (uri.auth ? uri.auth + '@' : '') + uri.host : '') + uri.path + (uri.hash || '');
    };
    var protocol_re = /^((?:about|http|https|file|ftp|ws|wss):)?(\/\/)?/i;
    var host_section_re = /^(.*?)(?:[/?#]|$)/;
    var host_re = /^(?:(([^:@]*):?([^:@]*))?@)?([a-zA-Z0-9._+-]*)(?::(\d*))?/;
    var path_section_re = /^([^?#]*)(\?[^#]*)?(#.*)?$/;
    var path_re_loose = /^(\/(?:.(?![^/]*\.[^/.]+$))*\/?)?([^/]*?(?:\.([^.]+))?)$/;
    var path_re_strict = /^(\/(?:.(?![^/]*(?:\.[^/.]+)?$))*\/?)?([^/]*?(?:\.([^.]+))?)$/;
    E.parse = function (url, strict) {
      function re(expr, str) {
        var m;
        try {
          m = expr.exec(str);
        } catch (e) {
          m = null;
        }
        if (!m) return m;
        for (var i = 0; i < m.length; i++) m[i] = m[i] === undefined ? null : m[i];
        return m;
      }
      url = url || location.href;
      var uri = {
        orig: url
      };
      url = replace_slashes(url);
      var m,
        remaining = url;
      // protocol
      if (!(m = re(protocol_re, remaining))) return {};
      uri.protocol = m[1];
      if (uri.protocol !== null) uri.protocol = uri.protocol.toLowerCase();
      uri.slashes = !!m[2];
      if (!uri.protocol && !uri.slashes) {
        uri.protocol = 'http:';
        uri.slashes = true;
      }
      remaining = remaining.slice(m[0].length);
      // host
      if (!(m = re(host_section_re, remaining))) return {};
      uri.authority = m[1];
      remaining = remaining.slice(m[1].length);
      // host elements
      if (!(m = re(host_re, uri.authority))) return {};
      uri.auth = m[1];
      uri.user = m[2];
      uri.password = m[3];
      uri.hostname = m[4];
      uri.port = m[5];
      if (uri.hostname !== null) {
        uri.hostname = uri.hostname.toLowerCase();
        uri.host = uri.hostname + (uri.port ? ':' + uri.port : '');
      }
      // path
      if (!(m = re(path_section_re, remaining))) return {};
      uri.relative = m[0];
      uri.pathname = m[1];
      uri.search = m[2];
      uri.query = uri.search ? uri.search.substring(1) : null;
      uri.hash = m[3];
      // path elements
      if (!(m = re(strict ? path_re_strict : path_re_loose, uri.pathname))) return {};
      uri.directory = m[1];
      uri.file = m[2];
      uri.ext = m[3];
      if (uri.file == '.' + uri.ext) uri.ext = null;
      // finals
      if (!uri.pathname) uri.pathname = '/';
      uri.path = uri.pathname + (uri.search || '');
      uri.href = E.uri_obj_href(uri);
      return uri;
    };
    E.qs_parse = function (q, opt) {
      var obj = {};
      opt = opt || {};
      q = q.length ? q.split('&') : [];
      var len = q.length;
      var unescape_val = opt.bin ? function (val) {
        return qs.unescapeBuffer(val, true).toString('binary');
      } : opt.safe ? function (val) {
        try {
          return decodeURIComponent(val.replace(/\+/g, ' '));
        } catch (e) {
          return val;
        }
      } : function (val) {
        return decodeURIComponent(val.replace(/\+/g, ' '));
      };
      for (var i = 0; i < len; ++i) {
        var x = q[i];
        var idx = x.indexOf('=');
        var kstr = idx >= 0 ? x.substr(0, idx) : x;
        var vstr = idx >= 0 ? x.substr(idx + 1) : '';
        var k = unescape_val(kstr);
        var v = unescape_val(vstr);
        if (obj[k] === undefined) obj[k] = v;else if (Array.isArray(obj[k])) obj[k].push(v);else obj[k] = [obj[k], v];
      }
      // XXX mikita: not the best place for it, but the only reliable one for now
      if (!opt.disable_qid_parse) {
        var extend_obj = function extend_obj() {
          var obj_ext = JSON.parse(zstring.b64decode(obj.qid, opt));
          obj = assign(obj_ext, zutil.omit(obj, 'qid'));
        };
        while (obj.qid) {
          if (opt.safe) try {
            extend_obj();
          } catch (e) {
            obj = zutil.omit(obj, 'qid');
          } else extend_obj();
        }
      }
      return obj;
    };
    function token_regex(s, end) {
      return end ? '^' + s + '$' : s;
    }
    E.http_glob_host = function (host, end) {
      var port = '';
      var parts = host.split(':');
      host = parts[0];
      if (parts.length > 1) port = ':' + parts[1].replace('*', '[0-9]+');
      var n = host.match(/^(|.*[^*])(\*+)$/);
      if (n) {
        host = E.http_glob_host(n[1]) + (n[2].length == 1 ? '[^./]+' : '[^/]' + (n[1] ? '*' : '+'));
        return token_regex(host + port, end);
      }
      /* '**' replace doesn't use '*' in output to avoid conflict with '*'
       * replace following it */
      host = host.replace(/\*\*\./, '**').replace(/\*\./, '*').replace(/\./g, '\\.').replace(/\*\*/g, '(([^./]+\\.)+)?').replace(/\*/g, '[^./]+\\.');
      return token_regex(host + port, end);
    };
    E.http_glob_path = function (path, end) {
      if (path[0] == '*') return E.http_glob_path('/' + path, end);
      var n = path.match(/^(|.*[^*])(\*+)([^*^/]*)$/);
      if (n) {
        path = E.http_glob_path(n[1]) + (n[2].length == 1 ? '[^/]+' : '.*') + E.http_glob_path(n[3]);
        return token_regex(path, end);
      }
      path = path.replace(/\*\*\//, '**').replace(/\*\//, '*').replace(/\//g, '\\/').replace(/\./g, '\\.').replace(/\*\*/g, '(([^/]+\\/)+)?').replace(/\*/g, '[^/]+\\/');
      return token_regex(path, end);
    };
    E.http_glob_url = function (url, end) {
      var n = url.match(/^((.*):\/\/)?([^/]+)(\/.*)?$/);
      if (!n) return null;
      var prot = n[1] ? n[2] : '*';
      var host = n[3];
      var path = n[4] || '**';
      if (prot == '*') prot = 'https?';
      host = E.http_glob_host(host);
      path = E.http_glob_path(path);
      return token_regex(prot + ':\\/\\/' + host + path, end);
    };
    E.root_url_cmp = function (a, b) {
      var a_s = a.match(/^[*.]*([^*]+)$/);
      var b_s = b.match(/^[*.]*([^*]+)$/);
      if (!a_s && !b_s) return false;
      var re, s;
      if (a_s && b_s && a_s[1].length > b_s[1].length || a_s && !b_s) {
        s = a_s[1];
        re = b;
      } else {
        s = b_s[1];
        re = a;
      }
      s = E.add_proto(s) + '/';
      if (!(re = E.http_glob_url(re, 1))) return false;
      try {
        re = new RegExp(re);
      } catch (e) {
        return false;
      }
      return re.test(s);
    };
    E.qs_strip = function (url) {
      return /^[^?#]*/.exec(url)[0];
    };

    // mini-implementation of zescape.qs to avoid dependency of escape.js
    E.qs_str = function (_qs) {
      var q = [];
      for (var k in _qs) {
        (Array.isArray(_qs[k]) ? _qs[k] : [_qs[k]]).forEach(function (v) {
          q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
        });
      }
      return q.join('&');
    };
    E.qs_add = function (url, _qs, opt) {
      var u = E.parse(url),
        q = assign(u.query ? E.qs_parse(u.query, opt) : {}, _qs);
      u.path = u.pathname + '?' + E.qs_str(q);
      return E.uri_obj_href(u);
    };
    E.qs_parse_url = function (url, opt) {
      return E.qs_parse(url.replace(/(^.*\?)|(^[^?]*$)/, ''), opt);
    };
    E.qs_pack_qid = function (_qs) {
      return zstring.b64encode(JSON.stringify(_qs));
    };
    E.qs_str_qid = function (_qs) {
      return E.qs_str({
        qid: E.qs_pack_qid(_qs)
      });
    };
    E.url_qs_encode_qid = function (url, opt) {
      var u = E.parse(url),
        q = assign(u.query ? E.qs_parse(u.query, opt) : {});
      u.path = u.pathname + '?' + E.qs_str_qid(q);
      return E.uri_obj_href(u);
    };
    E.segments = function (url) {
      var parsed = E.parse(url || location.href);
      var dir = parsed.directory || '/';
      if (dir == '/') return [''];
      return dir.split('/');
    };

    // returns absolute url or undefined
    E.safe_redir = function (url, default_hostname) {
      if (!url) return;
      var u = E.parse(url, true);
      var hostname = u.hostname || default_hostname;
      if (!/^https?:$/.test(u.protocol) || !hostname) return;
      if (E.is_hola_domain(hostname) || zutil.is_mocha() && hostname == 'localhost') return 'https://' + hostname + encodeURI(u.path);
    };
    E.alt_holaorg = function (domain, kw) {
      if (domain == 'hola.org' && kw && kw.hola_org_blocked) return 'hola-vpn.com';
      return domain;
    };
    return E;
  });
})();